var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87109 12.6289L0.496094 8.25391C0.140625 7.92578 0.140625 7.35156 0.496094 7.02344C0.824219 6.66797 1.39844 6.66797 1.72656 7.02344L4.625 9.89453V1.5C4.625 1.03516 5.00781 0.625 5.5 0.625C5.96484 0.625 6.375 1.03516 6.375 1.5V9.89453L9.24609 7.02344C9.57422 6.66797 10.1484 6.66797 10.4766 7.02344C10.832 7.35156 10.832 7.92578 10.4766 8.25391L6.10156 12.6289C5.77344 12.9844 5.19922 12.9844 4.87109 12.6289Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDark);
export default __webpack_public_path__ + "static/media/arrow_down_dark.dfedee524e41aa83df59c87743564e21.svg";
export { ForwardRef as ReactComponent };